module.exports = __webpack_public_path__ + "img/bg-camera-tablet.ac6eaf19.png";